// extracted by mini-css-extract-plugin
export default {"card":"FormSuccess_card__XY4YT","container":"FormSuccess_container__i+MZK","btn":"FormSuccess_btn__wPy7U"};